module.exports = __webpack_public_path__ + "img/Frame 5135.a9adf7b0.jpg";